import type { PaginatedList } from './common';

export type PaymentMethodType =
  | 'KBZPAY'
  | 'WAVE_PAY'
  | 'CBPAY'
  | 'AYA_PAY'
  | 'MPT_MONEY'
  | 'VISA'
  | 'MASTER'
  | 'MMQR'
  | 'BANK_TRANSFER'
  | 'CASH'
  | 'OTHER';

export const PAYMENT_METHOD_TYPES: Array<{ value: PaymentMethodType; label: string }> = [
  { value: 'KBZPAY', label: 'KBZPay' },
  { value: 'WAVE_PAY', label: 'Wave Pay' },
  { value: 'CBPAY', label: 'CBPay' },
  { value: 'AYA_PAY', label: 'AYA Pay' },
  { value: 'MPT_MONEY', label: 'MPT Money' },
  { value: 'VISA', label: 'Visa' },
  { value: 'MASTER', label: 'Mastercard' },
  { value: 'MMQR', label: 'MMQR' },
  { value: 'BANK_TRANSFER', label: 'Bank Transfer' },
  { value: 'CASH', label: 'Cash' },
  { value: 'OTHER', label: 'Other' },
];

export interface PaymentMethod {
  paymentMethodId: string;
  name: string;
  paymentType: PaymentMethodType;
  description?: string | null;
  logoUrl?: string | null;
  qrImageUrl?: string | null;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface PaymentMethodCreateRequest {
  name: string;
  paymentType: PaymentMethodType;
  description?: string | null;
  logoUrl?: string | null;
  qrImageUrl?: string | null;
  isActive: boolean;
  sortOrder: number;
}

export interface PaymentMethodUpdateRequest {
  name?: string;
  paymentType?: PaymentMethodType;
  description?: string | null;
  logoUrl?: string | null;
  qrImageUrl?: string | null;
  isActive?: boolean;
  sortOrder?: number;
}

export type PaymentMethodsData = PaginatedList<PaymentMethod>;

export type PaymentMethodQueryParams = {
  page?: number;
  size?: number;
};

